// src/components/LoadingSpinner.js
import React from "react";
import "./LoadingSpinner.css";

export function LoadingSpinner({ size = "medium", message, fullScreen = false }) {
  const sizeClass = `spinner--${size}`;
  const containerClass = fullScreen ? "loading-spinner-fullscreen" : "loading-spinner-container";

  return (
    <div
      className={containerClass}
      role="status"
      aria-live="polite"
      aria-label={message || "Loading"}
    >
      <div className={`spinner ${sizeClass}`} aria-hidden="true">
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
      </div>
      {message && <p className="loading-spinner-message">{message}</p>}
    </div>
  );
}

export default LoadingSpinner;
